module.exports = __webpack_public_path__ + "static/logohc-60bb4b86141215ea3b8b57e2dd150b0a.svg";